<script lang="ts" setup>
import { ErrorMessage } from 'vee-validate'
import { type HTMLAttributes, toValue } from 'vue'
import { cn } from '@/lib/utils'
import { useFormField } from './useFormField'

const props = defineProps<{
    class?: HTMLAttributes['class']
}>()

const { name, formMessageId } = useFormField()
</script>

<template>
    <ErrorMessage
        :id="formMessageId"
        as="p"
        :name="toValue(name)"
        :class="cn('text-destructive font-medium text-xs', props.class)"
    />
</template>
